export const END_CURSOR = 'LTE=';
